import React from "react";
import { get, isEmpty, sortBy, filter, includes } from "lodash";

import { fetchPost } from "../../../api/fetch";

import Box from "@material-ui/core/Box";
import CircularProgress from "@material-ui/core/CircularProgress";

import MeasuredTemperatureDialog from "../../SiteEntranceExit/Temperature/MeasuredTemperatureDialog";

import { getAttributeValue } from "../../../utils/profile";

import { eventGroupsData } from "../../../constants/eventGroups";

import images from "../../../assets/img/images";
import { MANUAL_TYPE } from "../../../constants/common";
import { getMeasureType } from "../../../utils/temperature";

const HspTemperatureDialog = (props) => {
  const { item, language } = props;
  const [data, setData] = React.useState();
  const [open, setOpen] = React.useState(false);
  const [isFetching, setIsFetching] = React.useState(false);

  const fetchData = async () => {
    setIsFetching(true);
    try {
      let res = await fetchPost("new/event_groups", {
        filter: {
          parent_ids: [get(item, ["event_group_parent_id"])],
          types: [13],
        },
        data: eventGroupsData,
      });
      setData(get(res, ["items", 0]));
    } catch (e) {
      console.log(e);
    }
    setIsFetching(false);
  };

  const handleClick = () => {
    if (get(item, ["event_group_parent_id"])) {
      fetchData();
      setOpen(true);
    }
  };

  if (isFetching) {
    return (
      <Box className="flexCenter" style={{ paddingLeft: 10 }}>
        <CircularProgress size={16} />
      </Box>
    );
  }

  if (isEmpty(data)) {
    return (
      <img
        src={
          get(item, ["fever"]) === true
            ? images.temperatureButtonRed
            : get(item, ["fever"]) === false
            ? images.temperatureButtonGreen
            : images.temperatureButtonDisabled
        }
        alt="temperature_status"
        style={{
          cursor:
            includes([true, false], get(item, ["fever"])) &&
            get(item, ["event_group_parent_id"])
              ? "pointer"
              : "",
        }}
        onClick={
          includes([true, false], get(item, ["fever"])) ? handleClick : null
        }
      />
    );
  }

  const oldestMeasure = get(
    sortBy(
      filter(get(data, ["events"]), (e) => get(e, ["type", "id"]) === 82),
      (e) => get(e, ["created_on"])
    ),
    [0]
  );
  let startTime = 0;
  if (!isEmpty(oldestMeasure)) {
    startTime = new Date(
      getMeasureType(oldestMeasure) === MANUAL_TYPE
        ? oldestMeasure.created_on
        : getAttributeValue(oldestMeasure, 13)
    ).getTime();
  }

  return (
    <MeasuredTemperatureDialog
      open={open}
      onOpen={() => setOpen(true)}
      onClose={() => setOpen(false)}
      language={language}
      data={data}
      startTime={startTime}
    />
  );
};

export default HspTemperatureDialog;
